import { Td, Text } from "@chakra-ui/react";
import { Badge, BadgeColorSchema } from "../../badge";

type TdStatusProps = {
  status: string;
  failureReason?: string;
};

export function TdStatus({ status, failureReason }: TdStatusProps) {
  const colorMap = {
    pending: "pending",
    succeeded: "success",
    failed: "failed",
    default: "default",
  };

  return (
    <Td>
      <Badge
        colorScheme={colorMap[status.toLowerCase() as keyof typeof colorMap] as BadgeColorSchema}
      >
        {status}
      </Badge>
      {failureReason && (
        <Text fontSize="xs" color="#6C6B6E">
          {failureReason}
        </Text>
      )}
    </Td>
  );
}
